import type {
  LumpsumFundDistributionStatus,
  LumpsumImportantNote,
  LumpsumPlanRecommendationCounterFund,
  LumpsumPlanRecommendationStatusReason,
  LumpsumPlanRecommendationTaxData
} from './recommendation.types'

export enum LumpsumRebalanceImportantNoteStaticType {
  BUY_FUND_NON_RANK_ONE = 'BUY_FUND_NON_RANK_ONE',
  SWP_TRANSFER = 'SWP_TRANSFER',
  SELL_FUND_IDCW = 'SELL_FUND_IDCW',
  SELL_FUND_ELSS = 'SELL_FUND_ELSS',
  SELL_FUND_ON_TRACK = 'SELL_FUND_ON_TRACK',
  HIGH_EXPOSURE_SWITCH = 'HIGH_EXPOSURE_SWITCH'
}

export interface LumpsumRebalanceImportantNotes {
  ruleBased?: (LumpsumRebalanceImportantNoteStaticType | string)[] | null
  factBasedCuratedNotes?: LumpsumImportantNote[] | null
}

export interface LumpsumRebalanceSellPlanRecommendationDetails extends LumpsumPlanRecommendationStatusReason {
  isin: string | null
  fundName: string | null
  fundCategory: string | null
  fundNature: string | null
  purchaseMode: string | null
  distributionStatus: LumpsumFundDistributionStatus | null
  elss: boolean | null
  stcg: boolean | null
  taxCategory: string | null
  powerRating: string | null
  powerRank: number | null
  mfLogoUrl: string | null
  currentValue: number | null
  totalTransferAmount: number | null
  planSnapshotDate: number | null
  executed: boolean | null
  consolidatedTax?: LumpsumPlanRecommendationTaxData | null
  fundsToBeBought: LumpsumPlanRecommendationCounterFund[] | null
  importantNotes?: LumpsumRebalanceImportantNotes | null
}

export interface LumpsumRebalanceBuyPlanRecommendationDetails extends LumpsumPlanRecommendationStatusReason {
  isin: string | null
  fundName: string | null
  fundCategory: string | null
  fundNature: string | null
  purchaseMode: string | null
  distributionStatus: LumpsumFundDistributionStatus | null
  elss: boolean | null
  stcg: boolean | null
  taxCategory: string | null
  powerRating: string | null
  powerRank: number | null
  mfLogoUrl: string | null
  currentValue: number | null
  totalTransferAmount: number | null
  planSnapshotDate: number | null
  executed: boolean | null
  consolidatedTax?: LumpsumPlanRecommendationTaxData | null
  fundsToBeSold: LumpsumPlanRecommendationCounterFund[] | null
  importantNotes?: LumpsumRebalanceImportantNotes | null
}

export type LumpsumRebalancePlanRecommendationApiResponse =
  | LumpsumRebalanceSellPlanRecommendationDetails
  | LumpsumRebalanceBuyPlanRecommendationDetails
